import { CommerceToolsApi } from '@grandvisionhq/commercetools';

const isContactLenses = (productType)=>CommerceToolsApi.isLenses(productType) || CommerceToolsApi.isContactLensBundle(productType)
;

export { isContactLenses };
//# sourceMappingURL=types.js.map
